<template>
  <div id="contenedor-contrato-directorios-tool-bar">
    <v-toolbar flat color="transparent">
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        rounded
        @click="nuevoDirectorio">
        <v-icon left small>
          mdi-plus
        </v-icon>
        Nuevo
      </v-btn>
    </v-toolbar>
  </div>
</template>

<script>
export default {
  name: 'ContratoDirectoriosToolBar',
  components: {
  },
  data() {
    return {};
  },
  methods: {
    nuevoDirectorio() {
      this.$emit('nuevoDirectorio');
    },
  },
};
</script>

<style lang="scss">

</style>
